function stickyCTA(){
  const form=q('form[action*="/cart/add"]');
  if(!form||q('.mr-sticky-product-cta'))return;

  const bar=document.createElement('div');
  bar.className='mr-sticky-product-cta';

  const title=q('.product-info h1')?.textContent||document.title;

  bar.innerHTML='<div><strong>'+
    title.replace(/</g,'&lt;').slice(0,70)+
    '</strong><small>MONSREMORQUE</small></div>'+
    '<button type="button" class="mr-btn mr-btn--red">'+((window.mrI18n&&window.mrI18n.add_to_cart)||'Ajouter au panier')+'</button>';

  document.body.appendChild(bar);

  bar.querySelector('button').addEventListener(
    'click',
    ()=>form.requestSubmit()
  );

  const io=new IntersectionObserver(
    es=>bar.classList.toggle(
      'is-visible',
      !es[0].isIntersecting
    ),
    {threshold:.05}
  );

  io.observe(form);
}